import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { request, baseUrl } from './utils/request'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}
app.use(store).use(router).use(ElementPlus)
app.config.globalProperties.$request = request
app.config.globalProperties.$baseUrl = baseUrl
app.mount('#app')